module.exports = __webpack_public_path__ + "img/relatorios.4c588f93.svg";